import collectionIcons from './*.png';

export default collectionIcons;
